module.exports = __webpack_public_path__ + "fonts/XTypewriter-Regular.3ca87de.otf";